import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {StringUtil} from './StringUtil';

export class NgbDateStructUtil {

  public static toString(date: NgbDateStruct): string {
    if (date) {
      return StringUtil.addZeros(date.day) + '-' + StringUtil.addZeros(date.month) + '-' + date.year;
    }
    return '';
  }

  public static toString2(date: NgbDateStruct): string {
    if (date) {
      return StringUtil.addZeros(date.day) + '/' + StringUtil.addZeros(date.month) + '/' + date.year;
    }
    return '';
  }

  public static toString2YYYYMMdd(date: NgbDateStruct): string {
    if (date) {
      return date.year + '-' + StringUtil.addZeros(date.month) + '-' + StringUtil.addZeros(date.day) + '-';
    }
    return '';
  }
}
